import React, { useEffect, useRef } from "react"
import { Text, TextStyle } from "react-native"

type Props = {
  text: string
  speed?: number
  style?: TextStyle | TextStyle[]
  restartDelay?: number
  onComplete?: () => void
}

const Typewriter: React.FC<Props> = ({ text, speed = 500, style, restartDelay, onComplete }) => {
  const [displayedText, setDisplayedText] = React.useState("")
  const onCompleteRef = useRef(onComplete)
  onCompleteRef.current = onComplete

  useEffect(() => {
    let index = 0
    let cancelled = false
    let stepTimer: ReturnType<typeof setTimeout> | undefined
    let restartTimer: ReturnType<typeof setTimeout> | undefined

    const step = () => {
      if (cancelled) return
      if (index >= text.length) {
        if (onCompleteRef.current) onCompleteRef.current()
        if (restartDelay && restartDelay > 0) {
          restartTimer = setTimeout(() => {
            if (cancelled) return
            index = 0
            setDisplayedText("")
            stepTimer = setTimeout(step, speed)
          }, restartDelay)
        }
        return
      }
      index += 1
      setDisplayedText(text.slice(0, index))
      stepTimer = setTimeout(step, speed)
    }

    setDisplayedText("")
    stepTimer = setTimeout(step, speed)

    return () => {
      cancelled = true
      if (stepTimer) clearTimeout(stepTimer)
      if (restartTimer) clearTimeout(restartTimer)
    }
  }, [text, speed, restartDelay])

  return (
    <Text style={style}>{displayedText}</Text>
  )
}

export default Typewriter
